import React, { useEffect, useState } from "react";
import { saveAssignment, fetchAccess } from "../Api";
import { useLocation } from "react-router-dom";

export default function AssignmentModal({ onClose }) {
  const [accessData, setAccessData] = useState({ email: "", course_category: "" });
  const [file, setFile] = useState(null);
  const location = useLocation();
  const [assignmentData, setAssignmentData] = useState({
    full_name: "",
    message: "",
  });

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const categoryFromURL = params.get("category") || "";

  fetchAccess()
    .then((res) => {
      // console.log("fetchAccess response:", res); // DEBUG
      if (res.status === 200) {
        let email = "";
        if (Array.isArray(res.data)) {
          const accessItem = res.data.find(item => parseInt(item.giveAccess) === 1);
          if (accessItem) {
            email = accessItem.email || "";
          }
        } else if (typeof res.data === "object" && res.data.email) {
          email = res.data.email;
        }

        setAccessData({
          email: email,
          course_category: categoryFromURL, // Take category from URL
        });

      } else {
        setAccessData({ email: "", course_category: categoryFromURL });
      }
    })
    .catch((error) => {
      console.error("fetchAccess failed:", error);
      setAccessData({ email: "", course_category: categoryFromURL });
    });
}, [location.search]);


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();
  formData.append("email", accessData.email);
  formData.append("course_category", accessData.course_category);
  formData.append("full_name", assignmentData.full_name);
  formData.append("message", assignmentData.message);
  formData.append("assignment_file", file);

  try {
    const response = await saveAssignment(formData); // Sending data to backend

    // console.log("API Response:", response); // Log entire response
    // console.log("Full response from saveAssignment:", response);

    if (response.status === 200) {
      alert("Assignment uploaded successfully!");
      onClose(); // Close the modal
    } else if (response.status === 400) {
      alert("Bad Request: " + (response.message || "Some required fields might be missing."));
    } else if (response.status === 500) {
      alert("Server Error: " + (response.message || "Could not save assignment."));
    } else {
      alert("Unexpected Error: " + (response.message || "Unknown response from server."));
    }
  } catch (error) {
    console.error("Upload failed:", error);
    alert("Network or JavaScript error occurred. Please check console.");
  }
};


  return (
    <div className="modal fade show d-block text-left" tabIndex="-1" role="dialog" aria-modal="true">
      <div role="document" className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title"><strong>Upload Assignment</strong></h4>
            <button type="button" onClick={onClose} className="close" style={{ border: 'none', backgroundColor: 'white' }}>
              {/* SVG Close Icon */}
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="40" height="40" viewBox="0 0 32 32">
              <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 12.21875 10.78125 L 10.78125 12.21875 L 14.5625 16 L 10.78125 19.78125 L 12.21875 21.21875 L 16 17.4375 L 19.78125 21.21875 L 21.21875 19.78125 L 17.4375 16 L 21.21875 12.21875 L 19.78125 10.78125 L 16 14.5625 Z"></path>
              </svg>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-2">
                <label>Email</label>
                <input 
                  type="email" 
                  name="email" 
                  value={accessData.email} 
                  className="form-control" 
                  disabled 
                />
              </div>
              <div className="form-group mb-2">
                <label>Course Category</label>
                <input 
                  type="text" 
                  name="course_category" 
                  value={accessData.course_category} 
                  className="form-control" 
                  disabled 
                />
              </div>
              <div className="form-group mb-2">
                <label>Your Name</label>
                <input 
                  type="text" 
                  name="full_name" 
                  className="form-control" 
                  placeholder="Your Full Name" 
                  onChange={(e) => setAssignmentData({...assignmentData, full_name: e.target.value})} 
                  required 
                />
              </div>
              <div className="form-group mb-2">
                <label>Message</label>
                <textarea 
                  name="message" 
                  className="form-control" 
                  placeholder="Message for Instructor.." 
                  onChange={(e) => setAssignmentData({...assignmentData, message: e.target.value})} 
                />
              </div>
              <div className="form-group mb-2">
                <label>Upload Assignment File</label>
                <input 
                  type="file" 
                  name="assignment_file" 
                  className="form-control" 
                  accept=".pdf,.doc,.docx,.zip,.csv" 
                  onChange={handleFileChange} 
                  required 
                />
              </div>
              <div className="modal-footer">
                <button type="button" onClick={onClose} className="btn btn-secondary">Close</button>
                <button type="submit" className="btn btn-info">Upload</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
